import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { Button } from '../Button';

export const FocusSkip = styled(Button).attrs(() => ({
  $tone: 'secondary',
  $variant: 'square',
}))`
  position: absolute;
  top: ${size(2)};
  left: ${size(2)};
  z-index: ${(props) => props.theme.zindex.focusskip};

  &:not(:focus) {
    width: 1px;
    height: 1px;
    clip-path: inset(50%);
    overflow: hidden;
    white-space: nowrap;
  }
`;
